// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1UBab","col":"styles_col__1pKXg"};